import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import { TextField, Button, IconButton, Table, TableHead, TableBody, TableRow, TableCell, InputAdornment, makeStyles, useMediaQuery } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import './index.css'
import Header from '../Header'
import Loading from '../LoadingComponent'
import { ReactComponent as Search } from '../../assets/search.svg'
import axios from 'axios'
import moment from 'moment'
import { getHostName } from '../../base.js'
import { ReactComponent as Arrow } from '../../assets/arrow.svg'
import COLORS from '../../colors.js'
import { useSwipeable } from 'react-swipeable'
 
const useStyles = makeStyles((theme) => ({
	input: {
	  	background: '#F2F2F2',
	  	borderRadius: '2rem',
		margin: '1rem',
	},
	table: {
		width:'100%',       
  	},
	tableRow: {
		cursor:'pointer', 
		textDecoration:'none',
		'&:hover': {
			  zIndex: '1000',
			  backgroundColor: COLORS.gray,
		}
  	},
  	arrow: {
		padding:'1rem',
		paddingTop: '1.4rem',
        margin:0,
		 
  	},
  	idHead: {
		padding:'1rem',
		paddingTop:'0.6rem',
        paddingBottom:'0.6rem',
		margin:0,
		color:'#5F6767',
		fontSize:'0.8rem',
		fontWeight:'400',
  	},
  	dateHead: {	 
		color:'#5F6767',
		fontSize:'0.8rem',
		fontWeight: '400',	 
  	},
  	amountHead: {
		margin:0,
		paddingRight:'1rem',
		color:'#5F6767',
		fontSize:'0.8rem',
		fontWeight: '400', 
	},	
  	idBody: {
		padding:'1rem',
		color: COLORS.blue,
		fontWeight: '700',    
  	},
  	dateBody:{
		padding:0,
		color: '#9EA5AD',
		fontWeight: '400',
  	},
	amountBody: {
		padding:0,
		fontWeight: '700',
	}   
  }));
  
const TransactionHistory = ({ cid, token, transactionList, itemDetails }) => {
		const matches = useMediaQuery('(min-width:780px)')
		const [ history, setHistory ] = useState([])
		const [ isLoading, setIsLoading ] = useState(true)
		const [ searchBy, setSearchBy ] = useState(false)
		const [ searchArr, setSearchArr ] = useState([])
		const [ searchString, setSearchString ] = useState('')
		const { detailsLst, setPrevPage, resetPN, setTransactionList, setPageNumber, signOut } = useContext(AuthContext)
		const params = useParams()
		const navigate = useNavigate()
		const classes = useStyles()
		const currDate = new Date()
		// setup ref for your usage
		const myRef = useRef();
		const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

		const handleLeftSwipe = () => {
			resetPN()
			navigate(`/kekspos/${params.tid}`)	
		}

		const handleRightSwipe = () => {
			if(itemDetails!==null)
			{
					setPageNumber(4)
					setTimeout(() => 
					{
						navigate(`/kekspos/${params.tid}/detalji/${itemDetails.keksId}`)
					}, 0)
			}
		}
	
		const refPassthrough = (el) => {
				// call useSwipeable ref prop with el
				handlers.ref(el)
				// set myRef el so you can access it yourself
				myRef.current = el
		}

		const toggleSearchBy = () => {
			 setSearchBy(searchBy => !searchBy)
	  	}

  		const handleSearch = (event) => {
				event.persist();
				setSearchString(event.target.value)
  		}

  		useEffect(() => {
			if(!searchBy)
		  	{
				  setSearchArr(history.filter( item => item.keksId.includes(searchString)))
		  	}else
		  	{
				  setSearchArr(history.filter( item => moment(item.epochtime).format("DD.MM.YYYY HH:MM").includes(searchString)))

		  	}

	 	}, [searchString, searchBy])

  		const handleDetails = (item) => {

				detailsLst(item)
  		}
		
    	useEffect(() => {
				setHistory(transactionList)
				setTimeout(() => setIsLoading(false), 1000)
 		},[])

		useEffect(() => {
			setPrevPage({prevPageNum:3})
			window.addEventListener('popstate', onBackButtonEvent)
		 
			return () => {
					window.removeEventListener('popstate', onBackButtonEvent);
			}
		}, [])

  		const onBackButtonEvent = (e) => {
			e.preventDefault()
			setPageNumber(null)
			navigate(`/kekspos/${params.tid}`)	 	 
  		}

		useEffect(() => 
		{   
			const handleReload = async (e) => 
			{
				e.preventDefault()
				signOut(cid)
				setTimeout(() => window.location.assign(`/kekspos`, 0));
				window.removeEventListener('beforeunload', handleReload) 	
				return false
			}
	  
			window.addEventListener("beforeunload", handleReload)
			   
			return () => 
			{    
				window.removeEventListener('beforeunload', handleReload) 
			}
		
		}, [])
  
  	if(!isLoading){
  		return (
    		<div className="history" {...handlers} ref={refPassthrough}>
	 			<Header pageNumber={3}/>
				<div className="history-main">
					<div className="input-search">
		 				<TextField 	variant="outlined"
									style={{width:!isMobile?'35rem':'100%'}}
						   			InputProps = {{	className: classes.input,
							 						startAdornment: (
														<InputAdornment position="start">
															<IconButton>
																<Search />
															</IconButton>
								 						</InputAdornment>
							 						)
						  						}}
						  			value={searchString}
						  			onChange = { (event) => handleSearch(event) }	  
			    		/>
					</div>
					<div className="history-body">
						<div className="history-table" style={{height:isMobile?'77vh':'75vh'}}>
								<Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                                    <TableHead >
                                            <TableRow>
												{matches&&<TableCell style={{width:'15%'}} component="td" scope="row"/>}
                                                <TableCell className={classes.idHead}
															style={{width:matches?'20%':'30%'}}  
															component="td" 
															scope="row"
															align="left"
													><Button style={{padding:0, 
																textTransform:'none',
																backgroundColor:!searchBy?COLORS.green:COLORS.blue,
																fontSize:!isMobile?'0.85rem':'0.82rem',
																paddingLeft:'5px',
																paddingRight:'5px',
																color:'#fff'}}
														disabled={!searchBy}
														onClick={()=>toggleSearchBy()}
													>ID računa</Button>
												</TableCell>
                                                <TableCell  className={classes.dateHead} 
															style={{width:matches?'30%':'40%'}}
															component="td" 
															scope="row" 
															align="center"
													><Button style={{padding:0, 
																textTransform:'none', 
																fontSize:matches?'0.85rem':'0.82rem',
																backgroundColor:!searchBy?COLORS.blue:COLORS.green, 
																color:'#fff'}}
														disabled={searchBy}
														onClick={()=>toggleSearchBy()}
													>Datum</Button>
												</TableCell>
                                                <TableCell className={classes.amountHead}
															style={{width:matches?'20%':'25%'}} 
															component="td" 
															scope="row" 
															align="right"
												>Iznos</TableCell>
                                                <TableCell style={{padding:0, margin:0, width:matches?'15%':'5%'}} 
															component="td" 
															scope="row" 
															align="left"
												/>
                                        	</TableRow>
                                    </TableHead>
									{history.length!==0?
                                    <TableBody>
                                        {searchArr.length===0?(
                                            history.map((item, keksId)=>
                                                <TableRow key={keksId} 
														className={classes.tableRow}
														component={Link}
														to={`/kekspos/${params.tid}/detalji/${item.keksId}`}
														onClick={()=>handleDetails(item)}>
													{matches&&<TableCell component="td" scope="row"/>}
                                                    <TableCell className={classes.idBody} 
																component="td" 
																scope="row" 
																align="left"
													>{item.keksId}</TableCell>
                                                    <TableCell  className={classes.dateBody}
                                                                component="td" 
                                                                scope="row" 
                                                                align="center"           
                                                    >{moment(item.epochtime).format("DD.MM.YYYY HH:mm")}</TableCell>
                                                    <TableCell className={classes.amountBody}
																style={{color:item.amountVoided===0?COLORS.green:'red'}} 
																component="td" 
																scope="row" 
																align="right"
													>{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</TableCell>
                                                    <TableCell className={classes.arrow} 
																component="td" 
																scope="row" 
																align="left"
													><Arrow/></TableCell>
                                                </TableRow>) 
                                                ):(
                                        searchArr.map((item, keksId) =>
												<TableRow key={keksId} 
														className={classes.tableRow}
														component={Link}
														to={`/kekspos/${params.tid}/detalji/${item.keksId}`} 
														onClick={() => handleDetails(item)}>
													{matches&&<TableCell component="td" scope="row" />}
													<TableCell className={classes.idBody} 
																component="td" 
																scope="row" 
																align="left"
													>{item.keksId}</TableCell>
													<TableCell className={classes.dateBody}
																component="td" 
																scope="row" 
																align="center"			  			 
													>
													{moment(item.epochtime).format("DD.MM.YYYY HH:mm")}</TableCell>
													<TableCell className={classes.amountBody}
																style={{color:item.amountVoided===0?COLORS.green:'red'}} 
																component="td" 
																scope="row" 
																align="right"
													>{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</TableCell>
													<TableCell className={classes.arrow} 
																component="td" 
																scope="row" 
																align="left"
													><Arrow/></TableCell>
												</TableRow>) 
                                            )} 
                                    </TableBody>:
									null}     
                                </Table> 
						</div>
					</div>
				</div>	
    		</div>
  	)
	}else{
		return(
			<div>
				<Loading />
			</div>
		)
	}
}

export default TransactionHistory

